export default __webpack_public_path__ + "static/media/News_Login_Left_Img.0244d222.svg";